import * as O from "fp-ts/Option"

/** Valeur partagée hors de React, lue par `useSyncExternalStore`. */
export type OptionStore<A> = {
  get: () => O.Option<A>
  set: (next: O.Option<A>) => void
  subscribe: (listener: () => void) => () => void
}

/**
 * Magasin d'une valeur optionnelle.
 * Chaque changement prévient les abonnés.
 *
 * @template A Type de la valeur gardée.
 * @example
 * const store = createOptionStore<string>()
 * store.set(O.some("a")) // chaque abonné est prévenu, store.get() rend O.some("a")
 */
export function createOptionStore<A>(): OptionStore<A> {
  // Seul état mutable du magasin : la valeur courante.
  const state: { current: O.Option<A> } = { current: O.none }
  const listeners = new Set<() => void>()
  return {
    get: () => state.current,
    set: (next) => {
      state.current = next
      for (const listener of listeners) listener()
    },
    subscribe: (listener) => {
      listeners.add(listener)
      return () => {
        listeners.delete(listener)
      }
    },
  }
}
